module.exports = __webpack_public_path__ + "img/right-leg_active.623ad7c5.png";